<ul>
    <ng-container
        *ngFor="let message of messages; index as i"
        aria-live="assertive"
    >
        <agpr-growl
            [message]="message"
            [id]="'growl_' + i"
        >
        </agpr-growl>
    </ng-container>
</ul>
